import { useState, useEffect } from 'react';
// API
import Api from '../../API';
import {
  getBestSellerFromLocalStorage,
  writeBestSellerToLocalStorage,
} from '../../utils/helpers';

const initialState = {
  last_update: '',
  next_update: '',
  books_list: [],
  total_results: 0,
};

export const useBestSellerFetch = () => {
  const [bestSellerState, setBestSellerState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // convert response lists into one list
  const getBestSellerStateFromResponse = (response) => {
    const updateList = (list, listName) => {
      return list.map((book) => ({ ...book, best_seller_list: listName }));
    };

    const hardcover = updateList(response.hardcover.books_list, 'hardcover');
    const manga = updateList(response.manga.books_list, 'manga');
    const science = updateList(response.science.books_list, 'science');

    const books_list = [...hardcover, ...manga, ...science];

    return {
      last_update: response.last_update,
      next_update: response.next_update,
      books_list,
      total_results: books_list.length,
    };
  };

  // first render
  useEffect(() => {
    const bestSeller = async () => {
      try {
        setLoading(true);
        setError(false);

        const savedBooks = getBestSellerFromLocalStorage();
        if (savedBooks) {
          setBestSellerState(savedBooks);
          setLoading(false);

          return;
        }

        const response = await Api.fetchBestSeller();
        const state = getBestSellerStateFromResponse(response);
        setBestSellerState(state);
        writeBestSellerToLocalStorage(state);
      } catch (error) {
        console.error(error.message);
        setError(true);
      }

      setLoading(false);
    };

    bestSeller();
  }, []);

  return { bestSellerState, loading, error };
};
